import captainInvoices from "./captainInvoices.component";
import captainInvoicesUrls from "./captainInvoices.urls";
import CaptainInvoicesTransforms from "./captainInvoices.transforms";

const captainInvoicesModule = angular
  .module("app.components.captainInvoices", [])
  .component("captainInvoicesPage", captainInvoices)
  .service("CaptainInvoicesTransforms", CaptainInvoicesTransforms)
  .config(captainInvoicesUrls);

export default captainInvoicesModule;



// WEBPACK FOOTER //
// ./src/pages/captainInvoices/captainInvoices.module.js